var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_briefcase",
    "data-name": "vuesax/bold/briefcase",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.381,
    height: 20.381,
    viewBox: "0 0 20.381 20.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.209,4.424a4.745,4.745,0,0,0-3.677-1.2h-.2V3.193c0-1.427,0-3.193-3.193-3.193H7.844C4.651,0,4.651,1.775,4.651,3.193v.042h-.2A4.732,4.732,0,0,0,.77,4.433,3.862,3.862,0,0,0,.04,7.482l.008.059.085.892s.611.408.917.577c.119.076.246.144.374.212a14.577,14.577,0,0,0,4.671,1.6c.076.8.425,1.732,2.284,1.732s2.225-.926,2.284-1.749a14.291,14.291,0,0,0,4.917-1.766c.051-.025.085-.051.127-.076a11.816,11.816,0,0,0,1.155-.764l.034-.306.042-.4c.008-.051.008-.093.017-.153A3.764,3.764,0,0,0,16.209,4.424ZM9.415,10.242c0,.9,0,1.036-1.045,1.036s-1.045-.161-1.045-1.028V9.18H9.415ZM5.866,3.227V3.193c0-1.444,0-1.979,1.979-1.979H9.135c1.979,0,1.979.544,1.979,1.979v.042H5.866Z",
    transform: "translate(1.701 1.503)",
    fill: "#5a607f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.424,0,16.05,4.116c-.178,1.7-.875,3.431-4.611,3.431H4.968C1.231,7.547.535,5.815.357,4.125L0,.2A33.668,33.668,0,0,0,4.756,2.07c.467,1.24,1.622,1.9,3.337,1.9a3.23,3.23,0,0,0,3.337-1.928A32.556,32.556,0,0,0,16.424,0Z",
    transform: "translate(1.987 11.331)",
    fill: "#5a607f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H20.381V20.381H0Z",
    transform: "translate(20.381 20.381) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/Accounts.b988146085bb9800fb42236247f05014.svg";
export { ForwardRef as ReactComponent };